import { store } from '../store.js';

// ── Dynamic Customer Homepage Blog Cards Rendering ──
export function renderBlogCards() {
  const grid = document.getElementById('blog-posts-grid');
  if (!grid) return;

  const blogs = store.getBlogs();
  const list = Object.entries(blogs).map(([slug, b]) => ({ slug, ...b }));
  
  // Sort newer dynamic ones first
  const sorted = list.sort((a, b) => {
    const timeA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
    const timeB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
    return timeB - timeA;
  });

  const displayPosts = sorted.slice(0, 6);

  grid.innerHTML = displayPosts.map((b, idx) => {
    const gradients = [
      'from-primary-600 to-cyan-500',
      'from-cyan-600 to-primary-500',
      'from-emerald-600 to-teal-500'
    ];
    const grad = gradients[idx % gradients.length];
    const iconName = b.category === 'Tiết kiệm' ? 'TrendingDown' : b.category === 'Bảo trì' ? 'Wrench' : 'BookOpen';
    
    const bannerHtml = b.image
      ? `<img src="${b.image}" alt="${b.title}" class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" decoding="async" />`
      : `<div class="absolute inset-0 flex items-center justify-center"><span class="text-white/40" data-lucide="${iconName}"></span></div>`;

    return `
      <a href="/blog/${b.slug}" class="w-[78vw] max-w-[300px] md:w-full md:max-w-none shrink-0 md:shrink snap-start snap-always block group bg-white rounded-2xl overflow-hidden shadow-card hover:shadow-card-hover transition-all duration-300 border border-gray-100/80 cursor-pointer flex flex-col">
        <div class="relative h-48 bg-gradient-to-br ${grad} overflow-hidden shrink-0">
          ${bannerHtml}
          <div class="absolute top-3 left-3 z-10">
            <span class="inline-flex items-center bg-white/95 backdrop-blur-md text-primary-700 text-xs font-bold px-3 py-1 rounded-full shadow-sm">
              ${b.category || 'Kiến thức'}
            </span>
          </div>
        </div>
        <div class="p-5 flex-1 flex flex-col justify-between">
          <div>
            <div class="flex items-center gap-3 text-xs text-gray-600 mb-3">
              <span class="flex items-center gap-1">
                <span data-lucide="Calendar" class="w-3.5 h-3.5"></span>
                ${b.date || 'Hôm nay'}
              </span>
              <span class="flex items-center gap-1">
                <span data-lucide="Clock" class="w-3.5 h-3.5"></span>
                ${b.readTime || '5 phút đọc'}
              </span>
            </div>
            <h3 class="text-lg font-bold text-gray-900 mb-2 group-hover:text-primary-600 transition-colors leading-snug line-clamp-2">
              ${b.title}
            </h3>
            <p class="text-sm text-gray-500 leading-relaxed mb-4 line-clamp-3">
              ${b.description || b.summary || ''}
            </p>
          </div>
          <div class="inline-flex items-center gap-1.5 text-sm font-bold text-primary-600 group-hover:text-primary-700 transition-colors mt-auto">
            <span>Đọc tiếp</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="transition-transform group-hover:translate-x-1.5">
              <path d="M5 12h14" />
              <path d="m12 5 7 7-7 7" />
            </svg>
          </div>
        </div>
      </a>
    `;
  }).join('');

  // Populate blog dots
  const blogDotsContainer = document.getElementById('blog-dots');
  if (blogDotsContainer) {
    blogDotsContainer.innerHTML = displayPosts.map((_, idx) => `
      <button class="carousel-dot ${idx === 0 ? 'active' : ''}" aria-label="Bài viết ${idx + 1}" data-index="${idx}"></button>
    `).join('');
  }

  if (typeof lucide !== 'undefined' && typeof lucide.createIcons === 'function') {
    lucide.createIcons();
  }
}
